import React, { useState, useEffect, useContext, useRef } from "react";
import facebook from "./Images/facebook.png";
import instagram from "./Images/instagram.png";
import { Flex, Input } from "antd";
import { useHistory } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import axios from "axios";
import Drawer from "@mui/material/Drawer";
import CloseImg from "./Images/CloseImg.png";
import { useTranslation } from "react-i18next";
import { AppContext, useAppContext } from "./AppContext";

import { MyDomain } from "./App";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1024
        ? "80%"
        : window.innerWidth <= 1440
        ? "50%"
        : window.innerWidth <= 1920
        ? "30%"
        : window.innerWidth <= 2560
        ? "50%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

export default function AskChooseLang() {
  const lang = JSON.parse(localStorage.getItem("lang"));
  //console.log(lang);
  const { Lang, setLang } = useAppContext();

  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const [openDone, setOpenDone] = useState(true);
  const [Choosing, setChoosing] = useState(lang);

  const handleClose2 = () => {
    setOpenDone(false);
  };

  // useEffect(() => {
  //   console.log(i18n.language);
  // }, []);
  function ModalDone() {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialog
            //onClose={handleClose2}
            aria-labelledby="customized-dialog-title"
            open={openDone}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            {/* <IconButton
                  aria-label="close"
                  onClick={handleClose2}
                  sx={(theme) => ({
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                  })}
                ></IconButton> */}

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(50vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    marginBottom: 20,
                  }}
                >
                  <a
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                    }}
                  >
                    {t("profile.Chooselanguage")}
                  </a>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      margin: 5,
                      padding: 0,
                      fontSize: 18,
                      color: Lang === "he" ? "black" : "#a1a1aa",
                      cursor: "pointer",
                      fontWeight: Lang === "he" ? "bold" : "",
                    }}
                    onClick={() => {
                      setChoosing(lang);
                      setLang("he");
                      changeLanguage("he");
                      localStorage.setItem("lang", JSON.stringify("he"));
                    }}
                  >
                    עברית
                  </p>
                  <p
                    style={{
                      margin: 5,
                      padding: 0,
                      fontSize: 18,
                      cursor: "pointer",
                      color: Lang === "ar" ? "black" : "#a1a1aa",
                      fontWeight: Lang === "ar" ? "bold" : "",
                    }}
                    onClick={() => {
                      setChoosing(lang);
                      setLang("ar");
                      changeLanguage("ar");
                      localStorage.setItem("lang", JSON.stringify("ar"));
                    }}
                  >
                    العربية
                  </p>
                  <p
                    style={{
                      margin: 5,
                      padding: 0,
                      fontSize: 18,
                      cursor: "pointer",
                      color: Lang === "en" ? "black" : "#a1a1aa",
                      fontWeight: Lang === "en" ? "bold" : "",
                    }}
                    onClick={() => {
                      setChoosing(lang);
                      setLang("en");
                      changeLanguage("en");
                      localStorage.setItem("lang", JSON.stringify("en"));
                    }}
                  >
                    English
                  </p>
                </div>
                {/* <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    marginTop: 40,
                  }}
                  onClick={() => {
                    handleClose2();
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.DoneLang")}</a>
                </button> */}
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </div>
    );
  }
  return <div>{lang === null ? <>{ModalDone()}</> : null}</div>;
}
